<template>
  <div class="ly-table">
    <!-- 2022.03.14 삭제 -->
    <!-- <div class="table-header">
      <span class="table-title"
        >{{ $t("messages.titStoragePaymentLog") }}
      </span>
    </div>
    <div class="table-count">
      {{ $t("messages.all") }}
      <span>{{ count }}</span>
      {{ $t("messages.unit") }}
    </div> -->
    <!-- //2022.03.14 삭제 -->
    <!-- 2022.03.14 추가 -->
    <div class="ly-sort ly-sort-his">
      <div class="sort-count">
        <p class="table-cell-all">
          {{ $t("messages.all") }}
          <span class="table-cell-count">{{ count }}</span
          >{{ $t("messages.unit") }}
        </p>
        <div class="sort-select">
          <el-select
            size="medium"
            v-model="count"
            :placeholder="$t('messages.plCount25')"
          >
            <el-option
              v-for="item in countList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <span>
            {{ $t("messages.perShow") }}
          </span>
        </div>
      </div>
      <el-button plain size="small" type="excel"
        >{{ $t("messages.btnExcel") }}<i class="icon-DownloadSimple"></i
      ></el-button>
    </div>
    <!-- //2022.03.14 추가 -->
    <div class="table-body">
      <idc-list :tableHeader="tableHeader" :tableData="tableData" />
      <idc-pagenation
        layout="prev, pager, next "
        :total="count"
      ></idc-pagenation>
    </div>
  </div>
</template>

<script>
import IdcList from "@/components/common/IdcList";
import IdcPagenation from "@/components/common/IdcPagenation";
export default {
  props: {
    svcContId: {
      default: "",
    },
  },
  components: {
    IdcList,
    IdcPagenation,
  },
  computed: {
    count() {
      return this.tableData.length;
    },
  },
  data() {
    return {
      tableHeader: [
        // 2022.03.14 셀 추가
        {
          prop: "",
          label: "서비스 ",
          width: "15",
        },
        {
          prop: "rmnySttusCdNm",
          label: "수납상태",
          width: "25",
        },
        {
          prop: "billAccId",
          label: "청구계약ID",
          width: "15",
        },
        {
          prop: "ddateDate",
          label: "납기일",
          width: "15",
        },
        // 2022.03.14 label명 수정
        {
          prop: "totBillAmt",
          label: "총 청구금액",
          width: "15",
        },
        {
          prop: "aplyAmt",
          label: "당월청구금액",
          width: "15",
        },
        {
          prop: "rmnyAmt",
          label: "당월수납금액",
          width: "15",
        },
        // 2022.03.14 셀 추가
        {
          prop: "",
          label: "계약ID ",
          width: "15",
        },
      ],
      tableData: [],
      countList: {
        lable: "5",
        value: 5,
      },
    };
  },
  mounted() {
    this.getBillDtlTxnList();
  },
  methods: {
    getBillDtlTxnList() {
      this.$BIZ_SERVICE
        .post(this.$API_URLS.Cus.getBillDtlTxnList, {
          svcContId: this.svcContId,
        })
        .then((res) => {
          console.log(res);

          if (res.data !== "") {
            this.tableData = res.data.resData;
          } else {
            this.tableData = [];
          }
        })
        .catch((error) => {})
        .finally(() => {});
    },
  },
};
</script>

<style></style>
